<template>
	<div class="blackscreen">
		<div class="cadastrar">
			<i class="fas fa-folder-plus"></i>
			<span class="titulo"> Criar nova coleção</span>
			<div class="nome"><input type="text" v-model="dados.nome" placeholder="Nome:"></div>
			<div class="descricao"><textarea type="text" v-model="dados.descricao" placeholder="Descrição:"/></div>
			<div class="btns">
				<div class="button descartar" @click="descartar">Descartar</div>
				<div class="button criar" @click="criar">Criar</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CadastrarColecao',
	data () {
		return {
			id: '',
			dados: {
				nome: '',
				comentario: '',
				descricao: '',
				usuarioId: this.$auth.user().id,
				colecaoId: ''
			},
			close: Boolean
		}
	},
	methods: {
		descartar () {
			this.$emit('close', false)
		},
		criar () {
			this.$emit('criar', this.dados)
		}
	}
}
</script>

<style lang="scss" scoped>
	.blackscreen {
		position: fixed;
		z-index: 4;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: #0007;
	}

	.cadastrar {
		background-color: #FEFEFE;
		display:flex;
		flex-direction: column;
		padding:10px;
		border-radius:5px;
		width: 584px;
		position:fixed;
		left: 50%;
		top: 30%;
		margin-left: -292px;

		i {
			color:#052354;
			font-size: 43px;
			margin-bottom: 18px;
		}

		.titulo {
			color:#052354;
			font-weight: 700;
			font-size: 20px;
			margin-bottom: 11px;
		}

		.nome {
			color:#EBECEF;
			border: 1px solid;
			border-radius: 5px;
			height: 40px;
			margin-bottom: 11px;

			input {
				background-color: #F8F9FB;
				color:#8B94A7;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				font: Condensed 16px Roboto;
			}
		}

		.descricao {
			height: 128px;
			margin-bottom: 16px;
			border: 1px solid;
			border-radius: 5px;
			background-color: #F8F9FB;
			color:#EBECEF;

			textarea {
				resize: none;
				overflow: hidden;
				background-color: inherit;
				color:#8B94A7;
				border: none;
				border-radius: 5px;
				width: 100%;
				height: 100%;
				padding: 10px;
				font: Condensed 16px Roboto;
			}
		}

		.btns {
			display:flex;
			justify-items: end;

			.button {
				display: flex;
				justify-content: center;
				width: 136px;
				height: 45px;
				padding: 0 20px;
				align-items: center;
				font-weight: 700;
				margin-right: 10px;
				cursor: pointer;
				transition: .333s all;
				text-transform: uppercase;

				&.descartar {
					background-color:#FFFFFF;
					border-radius:5px;
					border: 1px solid;
					border-color: #06162B;
					color:#06162B;

					&:hover {
						background-color: #E64141;
						color: #FFF;
						border-color: transparent;
					}
				}

				&.criar {
					background-color: #00659D;
					border-radius:5px;
					border: 1px solid;
					color:#FFFFFF;

					&:hover {
						background-color: #4191E6;
						color: #FFF;
						border-color: transparent;
					}
				}
			}
		}
	}
</style>
